import { render, staticRenderFns } from "./WorkingUnsolvedImportIssue.vue?vue&type=template&id=2d4360f0"
import script from "./WorkingUnsolvedImportIssue.vue?vue&type=script&lang=js"
export * from "./WorkingUnsolvedImportIssue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d4360f0')) {
      api.createRecord('2d4360f0', component.options)
    } else {
      api.reload('2d4360f0', component.options)
    }
    module.hot.accept("./WorkingUnsolvedImportIssue.vue?vue&type=template&id=2d4360f0", function () {
      api.rerender('2d4360f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/WorkingUnsolvedImportIssue.vue"
export default component.exports